// @flow
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fromJS } from 'immutable';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Loading from 'app/common/Loading';
import DwellingsList from 'app/dwellings/list';
import { list as listDwellings } from 'app/redux/modules/dwellings';
import { setTitle } from 'app/layout/redux';

import DwellingsTable from 'app/dwellings/table';

function filterList(props, tab) {
  const list = props.dwellings.get('data');

  if (!props.user || props.user.get('role') !== 'admin') {
    return list;
  }

  const statuses = typeof tab === 'string' ? tab.split('|') : null;
  const filtered = list.filter((item) => {
    if (tab === 'DEACTIVATED') {
      return !item.get('active');
    } else if (statuses) {
      return item.get('active') && statuses.includes(item.get('status'));
    }
    return true;
  });

  if (statuses && statuses.length > 1) {
    return filtered.sort((a, b) => {
      const x = statuses.indexOf(a.get('status'));
      const y = statuses.indexOf(b.get('status'));
      return x > y ? 1 : x < y ? -1 : 0;
    });
  }

  return filtered;
}

class Dashboard extends Component {
  static propTypes = {
    dwellings: PropTypes.object.isRequired,
    setTitle: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    const tab = 'PENDING_REVIEW|DRAFT';

    this.state = {
      tab,
      list: filterList(props, tab)
    };
  }

  componentDidMount() {
    if (this.props.user && this.props.user.get('role') !== 'admin') {
      this.props.listDwellings();
    }

    this.props.setTitle(this.props.i18n('Dwellings'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.dwellings !== nextProps.dwellings) {
      this.setState({
        list: filterList(nextProps, this.state.tab)
      });
    }
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  create = () => {
    this.props.navigate('/dwellings/create');
  };

  handleChange = (_, tab) => {
    this.setState({
      tab,
      list: filterList(this.props, tab)
    });
  };

  renderTabs() {
    return this.props.user && this.props.user.get('role') === 'admin' ? (
      <AppBar position="static" color="default">
        <Tabs
          value={this.state.tab}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={this.props.i18n('Draft')} value="PENDING_REVIEW|DRAFT" />
          <Tab label={this.props.i18n('Approved')} value="APPROVED" />
          <Tab label={this.props.i18n('All')} value="" />
          <Tab label={this.props.i18n('Deactivated')} value="DEACTIVATED" />
        </Tabs>
      </AppBar>
    ) : null;
  }

  render() {
    const { dwellings, user } = this.props;

    if (!user) {
      return null;
    }

    if (user.get('role') === 'admin') {
      return <DwellingsTable admin />;
    }

    return dwellings.get('data').size ? (
      <div>
        {this.renderTabs()}
        <Paper>
          <DwellingsList list={this.state.list} />
        </Paper>
      </div>
    ) : dwellings.get('loading') ? (
      <Loading />
    ) : (
      <Paper>
        <DwellingsList
          list={DUMMY_LIST}
          disabled
          style={{ borderBottom: '1px solid rgb(224, 224, 224)' }}
        />
        <div style={{ padding: '22px', textAlign: 'center' }}>
          <i>{this.props.i18n("You haven't created any dwellings yet")}</i>
          <br />
          <br />
          <Button
            primary
            autoFocus
            label={this.props.i18n('Create dwelling')}
            onClick={this.create}
          />
        </div>
      </Paper>
    );
  }
}

const DUMMY_LIST = fromJS([
  {
    location: { address: 'Vestergade 12, 3. th.', zip: '9999', city: 'Bynavn' },
    economy: { rent: 12345 },
    size: { rooms: 3, area: 124 }
  },
  {
    location: { address: 'Hovedgaden 34, 1.', zip: '9999', city: 'Bynavn' },
    economy: { rent: 6854 },
    size: { rooms: 2, area: 62 }
  }
]);

function DashboardWithNavigate(props) {
  const navigate = useNavigate();
  return <Dashboard {...props} navigate={navigate} />;
}

export default connect(
  ({ dwellings, auth: { user } }) => ({ dwellings, user }),
  {
    setTitle,
    listDwellings
  }
)(i18n(DashboardWithNavigate));